import React from "react";
import CelebrationButton from "../ui/CelebrationButton/CelebrationButton";
import { Send } from "lucide-react";

function PccDocumentationSection({
  DocumentFormData,
  handleDocumentInputChange,
  handleSave,
  isAnimate,
  inputClass,
}) {
  return (
    <>
      <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
        {/* <div className="w-full max-w-5xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-md p-6"> */}
        <div className="p-4 border-t border-slate-200 dark:border-slate-800">
          {/* Title */}
          <div className="text-center mb-6">
            <span className="text-blue-500 font-semibold underline text-sm">
              (PCC) PACIFIC COAST CONTAINER ( Documentation / Special Notes )
            </span>
          </div>

          {/* Export Notes */}
          <div className="grid grid-cols-12 items-start gap-4 mb-5">
            <label className="col-span-2 text-sm font-medium text-slate-700 dark:text-slate-300">
              Export Notes:
            </label>
            <div className="col-span-10">
              <textarea
                className={inputClass}
                name="specialnotesexport"
                value={DocumentFormData?.specialnotesexport || ""}
                onChange={handleDocumentInputChange}
              />
            </div>
          </div>

          {/* Import Notes */}
          <div className="grid grid-cols-12 items-start gap-4 mb-6">
            <label className="col-span-2 text-sm font-medium text-slate-700 dark:text-slate-300">
              Import Notes:
            </label>
            <div className="col-span-10">
              <textarea
                className={inputClass}
                name="specialnotesimport"
                value={DocumentFormData?.specialnotesimport || ""}
                onChange={handleDocumentInputChange}
              />
            </div>
          </div>

          {/* Footer Button */}
          <div className="flex justify-start">
            <CelebrationButton
              onClick={() => handleSave()}
              label={" Submit / Update"}
              className="bg-green-600 hover:bg-green-700 text-white p-2 rounded-md text-sm font-medium transition-all"
              icon={<Send className="w-4 h-4 mr-2" />} 
              isSuccess={isAnimate}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default PccDocumentationSection;
